export const STALE_STRIP_LABEL_PREFIX = 'Refreshed ';
export const STALE_STRIP_LABEL_MONTHS_SUFFIX = 'M ago';
export const STALE_STRIP_LABEL_YEARS_SUFFIX = 'Y ago';
export const STALE_STRIP_TOOLTIP_PREFIX = 'Last refreshed on ';
export const STALE_STRIP_TOOLTIP_SUFFIX = '. Some details may have changed since then. Refresh to see the latest.';

export const STALE_STRIP_VARIANT = { DESKTOP: 'desktop', MOBILE: 'mobile' } as const;
